import { toQuery } from 'src/utils/utils';

import { handleResponse } from '../utils/auth-header';
import axios, { axiosOption } from '../utils/axios';

export const DonhangsanphamService = {

  homepageList: (payload) => {
    return axios.post(`/api/v1/donhangsanpham/homepageList`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  homepageFindOne: (id) => {
    return axios.get(`/api/v1/donhangsanpham/homepageFindOne/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  homepageLimitList: (payload) => {
    return axios.post(`/api/v1/donhangsanpham/homepageLimitList`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  homepageLimitFindOne: (id) => {
    return axios.get(`/api/v1/donhangsanpham/homepageLimitFindOne/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  sendDonhangsanpham: (payload) => {
    return axios.post('/api/v1/donhangsanpham/sendDonhangsanpham', payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  create: (payload) => {
    return axios.post('/api/v1/donhangsanpham', payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  save: (payload) => {
    return axios.post('/api/v1/donhangsanpham/import', payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  update: (id, payload) => {
    return axios.put(`/api/v1/donhangsanpham/${id}`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  findAll: (page, count, payload) => {
    let url = `/api/v1/donhangsanpham?page=${page}&count=${count}`;

    if (payload.orderId) {
      url += `&orderId=${payload.orderId}`
    };
    
    if (payload.so_dien_thoai) {
      url += `&so_dien_thoai=${payload.so_dien_thoai}`
    };

    if (payload.so_dien_thoai_khach_dat) {
      url += `&so_dien_thoai_khach_dat=${payload.so_dien_thoai_khach_dat}`
    };

    if (payload.trang_thai) {
      url += `&trang_thai=${payload.trang_thai}`
    };

    if (payload.province) {
      url += `&province=${payload.province}`
    };

    if (payload.district) {
      url += `&district=${payload.district}`
    };

    if (payload.ward) {
      url += `&ward=${payload.ward}`
    };

    if (payload.province1) {
      url += `&province1=${payload.province1}`
    };

    if (payload.district1) {
      url += `&district1=${payload.district1}`
    };

    if (payload.ward1) {
      url += `&ward1=${payload.ward1}`
    };

    if (payload.address) {
      url += `&address=${payload.address}`
    };

    if (payload.startDate && payload.endDate) {
      url += `&startDate=${payload.startDate}&endDate=${payload.endDate}`
    }
    
    return axios.get(url, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  homepageList: (payload) => {
    return axios.post(`/api/v1/donhangsanpham/homepageList`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  listExport: (payload) => {
    let url = `/api/v1/donhangsanpham?page=${payload.page}&count=${payload.limit}`;

    if (payload.ten_goi_cuoc) {
      url += `&ten_goi_cuoc=${payload.ten_goi_cuoc}`
    };
    
    return axios.get(url, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  findAssign: (page, count) => {
    return axios.get(`/api/v1/donhangsanpham/assign?page=${page}&count=${count}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  find: (id) => {
    return axios.get(`/api/v1/donhangsanpham/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  homepageFindOne: (id) => {
    return axios.get(`/api/v1/donhangsanpham/homepageFindOne/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  findPackage: (ten_goi_cuoc) => {
    return axios.get(`/api/v1/donhangsanpham/findPackage/${ten_goi_cuoc}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  countAssign: () => {
    return axios.get(`/api/v1/donhangsanpham/count-assign`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  delete: (id) => {
    return axios.delete(`/api/v1/donhangsanpham/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  assign: (payload) => {
    return axios.post(`/api/v1/donhangsanpham/assign`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  history: (payload) => {
    return axios.get(`/api/v1/care/history?${toQuery(payload)}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  listNoLimit: () => {
    return axios.get(`/api/v1/donhangsanpham/listNoLimit`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },
}